import { LEVEL_BLOCAGE } from '@/configuration/clientConf';

export default function levelString(blocageLevel) {
  const level = LEVEL_BLOCAGE.find((l) => l.key === blocageLevel);
  return level ? level.libelle : '';
}



// WEBPACK FOOTER //
// ./src/services/client/levelToString.js